export const MOODS = [
  { key: "date night", label: "Date Night" },
  { key: "executive", label: "Executive" },
  { key: "cozy winter", label: "Cozy Winter" },
  { key: "fresh & clean", label: "Fresh & Clean" },
  { key: "tropical escape", label: "Tropical Escape" },
  { key: "night out", label: "Night Out" },
  { key: "everyday", label: "Everyday" },
  { key: "professional", label: "Professional" },
];

export const PRIMARY_NOTES = [
  "Amber", "Vanilla", "Oud", "Citrus", "Rose", "Cedar",
  "Saffron", "Sandalwood", "Musk", "Fig", "Coconut", "Vetiver",
];

export const GENDERS = [
  { key: "feminine", label: "Feminine" },
  { key: "unisex", label: "Unisex" },
  { key: "masculine", label: "Masculine" },
];

export const QUIZ_STEPS = [
  {
    key: "occasion",
    title: "The Occasion",
    subtitle: "When do you want to be remembered?",
    options: [
      { value: "everyday", label: "Everyday Signature", desc: "A scent that becomes you." },
      { value: "night out & dating", label: "Night Out & Dating", desc: "For candlelight and closeness." },
      { value: "professional", label: "Professional", desc: "Composed. Assured. Distinctive." },
      { value: "special events", label: "Special Events", desc: "Weddings, galas, milestones." },
    ],
  },
  {
    key: "season",
    title: "The Season",
    subtitle: "When will you wear it most?",
    options: [
      { value: "spring/summer", label: "Spring / Summer", desc: "Fresh, citrus, luminous." },
      { value: "autumn/winter", label: "Autumn / Winter", desc: "Warm, spicy, resinous." },
      { value: "year-round", label: "Year-Round", desc: "A signature for every season." },
    ],
  },
  {
    key: "sillage",
    title: "Sillage & Projection",
    subtitle: "How far should your scent travel?",
    options: [
      { value: "subtle", label: "Subtle & Intimate", desc: "A skin scent — close, murmured." },
      { value: "moderate", label: "Moderate", desc: "Noticeable within arm's reach." },
      { value: "powerful", label: "Powerful", desc: "Leaves a memorable trail." },
    ],
  },
  {
    key: "gender_tilt",
    title: "Personality Tilt",
    subtitle: "How would you describe the character?",
    options: [
      { value: "feminine", label: "Feminine", desc: "Floral, gourmand, luminous." },
      { value: "unisex", label: "Unisex", desc: "Balanced, sophisticated." },
      { value: "masculine", label: "Masculine", desc: "Woody, spicy, structured." },
    ],
  },
  {
    key: "familiar_scents",
    title: "Familiar Favorites",
    subtitle: "Which fragrances have you loved before?",
    multi: true,
    options: [
      { value: "Baccarat Rouge 540", label: "Baccarat Rouge 540" },
      { value: "Tom Ford Oud Wood", label: "Tom Ford Oud Wood" },
      { value: "Creed Aventus", label: "Creed Aventus" },
      { value: "YSL Black Opium", label: "YSL Black Opium" },
      { value: "Le Labo Santal 33", label: "Le Labo Santal 33" },
      { value: "Byredo Gypsy Water", label: "Byredo Gypsy Water" },
      { value: "Maison Margiela Beach Walk", label: "Maison Margiela Beach Walk" },
      { value: "Diptyque Philosykos", label: "Diptyque Philosykos" },
      { value: "Frederic Malle Portrait of a Lady", label: "Frederic Malle Portrait of a Lady" },
      { value: "Acqua di Parma Colonia", label: "Acqua di Parma Colonia" },
    ],
  },
];

export const CURRENCY_OPTIONS = [
  { code: "USD", label: "USD $" },
  { code: "EUR", label: "EUR €" },
  { code: "GBP", label: "GBP £" },
  { code: "CAD", label: "CAD $" },
  { code: "AUD", label: "AUD $" },
];
